import { useSearchParams } from 'react-router-dom';

// Keeps a page's tab selection in the URL (?tab=...) instead of plain
// component state, so a hard refresh (or a shared link) lands back on the
// same tab instead of silently resetting to the first one.
export function useTabState<T extends string>(defaultTab: T, validTabs: readonly T[]): [T, (next: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab');
  const tab = raw && (validTabs as readonly string[]).includes(raw) ? (raw as T) : defaultTab;

  const setTab = (next: T) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        params.set('tab', next);
        return params;
      },
      { replace: true },
    );
  };

  return [tab, setTab];
}
